<template>
    <Home />
</template>

<script>
// @ is an alias to /src
import Home from '@/components/Home.vue'

export default {
  name: 'HomePage',
  components: {
    Home
  },
  mounted() {
    // this.$analytics.logEvent("page_view");
    // this.$analytics.logEvent("screen_view", {
    //   screen_name: 'home',
    // });
  },
}
</script>
